// extracted by mini-css-extract-plugin
export var container = "_d6-0";
export var content = "_d6-3";
export var customerTitle = "_d6-4";
export var empty = "_d6-5";
export var gray = "_d6-6";
export var header = "_d6-7";
export var info = "_d6-8";
export var loading = "_d6-2";
export var loadingCard = "_d6-9";
export var oneLine = "_d6-a";
export var personName = "_d6-e";
export var pillContainer = "_d6-b";
export var selected = "_d6-1";
export var text = "_d6-c";
export var twoLines = "_d6-d";
export var unread = "_d6-f";
export var unreadIndicator = "_d6-g";